import { render } from "./Tool88Page_CaseBuddyForDevving.vue?vue&type=template&id=a85c352a&scoped=true"
import script from "./Tool88Page_CaseBuddyForDevving.vue?vue&type=script&lang=js"
export * from "./Tool88Page_CaseBuddyForDevving.vue?vue&type=script&lang=js"

import "./Tool88Page_CaseBuddyForDevving.vue?vue&type=style&index=0&id=a85c352a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85c352a"]])

export default __exports__